import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=520c356d&scoped=true&"
import script from "./ProfileNav.vue?vue&type=script&lang=ts&"
export * from "./ProfileNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c356d",
  null
  
)

export default component.exports